import * as React from 'react';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import qs from "query-string";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { globalFiltersRequired, restrictedPages } from "../helpers";
import { palette } from '../theme/ColorPalette';

const LOADING_COLOR = palette.lightSpaceGey

const CustomSlider = styled(Slider)({
  height: 12,
  cursor: 'pointer',
  padding: 0,
  margin: '13px 0',
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    display: 'none'
  },
});

const colors = {
  primary: palette.skyBlue,
  secondary: palette.peachPink,
  tertiary: palette.grey85
}

export default function ProgressChart({
  value1 = 0,
  value2 = 0,
  value1Title = null,
  value2Title = null,
  noRail = false,
  railColor = colors.secondary,
  loading = true,
  gotoPath,
  stopEventType = null,
  eventType = null,
  testid = 'progress-chart',
  ...rest
}) {
  const { carrierid } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  let color = colors[rest.color];
  let value = (value1 / (value1 + value2)) * 100;
  value = isNaN(value) ? 0: value;

  if (value === 0 && value2 > 0) {
    value = 100;
    color = colors.secondary;
  }

  const getCarrierResponseTypeForPayload = (type) => {
    switch (type) {
      case "PICKUP_ARRIVAL_CARRIER_RESPONSE_RECEIVED":
      case "DELIVERY_ARRIVAL_CARRIER_RESPONSE_RECEIVED":
        return "carrierArrivalResponseReceived";
      case "PICKUP_DEPARTURE_CARRIER_RESPONSE_RECEIVED":
      case "DELIVERY_DEPARTURE_CARRIER_RESPONSE_RECEIVED":
        return "carrierDepartureResponseReceived";
      case "PICKUP_ARRIVAL_CARRIER_RESPONSE_RECEIVED_ON_TIME":
      case "DELIVERY_ARRIVAL_CARRIER_RESPONSE_RECEIVED_ON_TIME":
        return "carrierArrivalResponseReceivedOnTime";
      case "PICKUP_DEPARTURE_CARRIER_RESPONSE_RECEIVED_ON_TIME":
      case "DELIVERY_DEPARTURE_CARRIER_RESPONSE_RECEIVED_ON_TIME":
        return "carrierDepartureResponseReceivedOnTime";
      default:
        return null;
    }
  }
  const goToPage = (e, titleClick) => {
    let isTrack;
    if (titleClick) {
      isTrack = titleClick === "Y";
    } else {
      const isTrackClass = e.target.className?.includes('track');
      isTrack = isTrackClass && value1 > 0;
    }

      const queries = qs.parse(location.search);
      let filtersRequired = {};
      globalFiltersRequired.map(d => {
          filtersRequired[d] = queries[d];
      });
      if(gotoPath === 'laneAwardCompliance') {
        navigate({
          ...location,
          search: qs.stringify({
              ...filtersRequired,
              awardCompliant: 'N',
              carrierCodeList: JSON.stringify([carrierid]),
          }),
          pathname: `/dashboard/performance/${carrierid}/${gotoPath}`,
      }, { replace: true })
      } else if(gotoPath === 'carrierEventResponse') {
        const carrierResponseKey = getCarrierResponseTypeForPayload(stopEventType);

        navigate({
          ...location,
          search: qs.stringify({
              ...filtersRequired,
              eventType: eventType,
              stopEventType: stopEventType,
              carrierCodeList: JSON.stringify([carrierid]),
              [carrierResponseKey]: JSON.stringify([isTrack ? "Y": "N"])
          }),
          pathname: `/dashboard/performance/${carrierid}/${gotoPath}`,
      }, { replace: true })
      } else if(gotoPath === 'trailerPoolCompliance') {
        navigate({
          ...location,
          search: qs.stringify({
              ...filtersRequired,
              trailerPoolCompliant: 'N',
              carrierCodeList: JSON.stringify([carrierid]),
          }),
          pathname: `/dashboard/performance/${carrierid}/${gotoPath}`,
      }, { replace: true })
      } else {
        const ontimeKey = gotoPath === "onTimePickup" ? "pickupOnTime": "deliveryOnTime";
      
        navigate({
            ...location,
            search: qs.stringify({
                ...filtersRequired,
                isPickedByPrimaryList: JSON.stringify([]),
                carrierCodeList: JSON.stringify([carrierid]),
                [ontimeKey]: JSON.stringify([isTrack ? "Y": "N"]),
            }),
            pathname: `/dashboard/performance/${carrierid}/${gotoPath}`,
        }, { replace: true })
      }      
  }
  
  return (<Box className='mb1'>
      <div className='subSubTitle'>
        <Typography variant='body1 pointer'data-testid={`${testid}-label`} onClick={(e) => goToPage(e, "Y")}>{loading ? "-": value1Title}</Typography>
        <Typography variant='body1 pointer'data-testid={`${testid}-value`} onClick={(e) => goToPage(e, "N")}>{loading ? "-": value2Title}</Typography>
      </div>
    {loading || value ? <CustomSlider
        loading={loading}
        onClick={goToPage}
        disabled={process.env.REACT_APP_ENV !== 'production' ? restrictedPages.includes(gotoPath) : [...restrictedPages, 'carrierEventResponse'].includes(gotoPath)}
        data-testid="progress-chart"
        componentsProps={{
          track: { 'data-testid': 'Progress-chart-track' },
        }}
        sx={{
          color: loading ? LOADING_COLOR : color,
          '& .MuiSlider-rail': {
            opacity: 1,
            backgroundColor: loading ? LOADING_COLOR :
              noRail ? colors.tertiary : railColor,
          }
        }}
        value={value}
      />
    : null}
    </Box>
  );
}